import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import { SuccessLogo } from "../../asset";
import PrimaryButton from "../button/PrimaryButton";

const ModalSuccessUpdated = ({ isVisible, onOk }) => {
  const { t } = useTranslation();
  return (
    <>
      <Modal
        visible={isVisible}
        closable={false}
        centered={true}
        width="298px"
        footer={null}
      >
        <div className="flex flex-col justify-center items-center gap-[9px]">
          <img src={SuccessLogo} alt="" />
          <div className="flex flex-col justify-center items-center">
            <h2 className="font-roboto text-3xl font-bold mb-[16px]">
              Success
            </h2>
            <p className="font-roboto text-[#666666] text-center mb-[16px] font-normal text-lg">
              Your data has been updated
            </p>
          </div>
        </div>
        <div className="content-center w-[218px] ml-4">
        <PrimaryButton
          text={t("USER_DETAIL:Ok")}
          action={onOk}
          styles="w-[218px] rounded-md"
        />
        </div>
      </Modal>
    </>
  );
};
export default ModalSuccessUpdated;
